/**
 * @author: leroy
 * @date: 2021/8/23 16:11
 * @description：counter
 */
import api from '@/utils/api';

export async function getCode(params: { phone: string; area_code: string; is_maotai?: number }) {
  return api<{ status: number | 'success'; message: any }>('/user/send-msg', {
    method: 'GET',
    params,
  });
}

export async function getAreaCodeList() {
  return api<{
    status: number | 'success';
    message: any;
    data: { name: string; value: string; id: string }[];
  }>('/user/area-code-list', {
    method: 'GET',
  });
}

export async function getExamUserInfo() {
  return api<{ status: number | 'success'; message: any; data: { id: string; phone: string } }>(
    '/user/get-info',
    {
      method: 'GET',
    },
  );
}

export async function codeLogin(data: {
  phone: string;
  code: string;
  area_code: string;
  anid?;
  exam: string;
}) {
  return api<{ message: string; status: string | number; login: { phone: string; auth: string } }>(
    '/user/login',
    {
      method: 'POST',
      data,
    },
  );
}

export async function getInfoByAnid(params: { anid: string }) {
  return api<{
    message: string;
    status: number | 'success';
    data: { phone: string; name: string; area_code; platform };
  }>('/exam/get-anid-info', {
    params,
  });
}
